import type { z } from "zod";
import { ApiRequestError } from "../api/client";

export type FieldErrors = Record<string, string>;

/** Client-side validation with the same Zod schema the API uses. */
export function validate<S extends z.ZodType>(
  schema: S,
  data: unknown,
): { ok: true; data: z.infer<S> } | { ok: false; errors: FieldErrors } {
  const r = schema.safeParse(data);
  if (r.success) return { ok: true, data: r.data };
  const errors: FieldErrors = {};
  for (const issue of r.error.issues) errors[issue.path.join(".") || "_"] ??= issue.message;
  return { ok: false, errors };
}

/** Splits an API failure into field errors and a form-level message. */
export function apiFailure(err: unknown): { fields: FieldErrors; message: string; code: string } {
  if (err instanceof ApiRequestError) {
    return { fields: err.fields, message: err.code === "validation" ? "" : err.message, code: err.code };
  }
  return { fields: {}, message: "A apărut o eroare neașteptată. Încearcă din nou.", code: "unknown" };
}
